import './FlowProgressBar.less';
import { FormSpecificationPage } from '../../models/be/db/FormSpecification';
import { hasValue } from '../../lib/utils';

export const getCurrentFlowProgressBarName = (pageSlug: string, formSpecificationPages: FormSpecificationPage[]) => {
	return formSpecificationPages.find((x) => x.slug === pageSlug)?.flowProgressBarName;
};

export const getFlowProgressBarNames = (formSpecificationPages: FormSpecificationPage[]) => {
	return formSpecificationPages.filter((x) => hasValue(x.flowProgressBarName)).map((x) => x.flowProgressBarName);
};
